import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useApi } from './Api';
const AuthContext = React.createContext(null);
const LoginContext = React.createContext(null);
export function useAuth() {
    return useContext(AuthContext);
}
export function withAuth(Component) {
    return function (props) {
        const [api] = useAuth();
        return React.createElement(Component, Object.assign({ api: api }, props));
    };
}
export function useLogin() {
    return useContext(LoginContext);
}
export default function AuthProvider({ tokenEndpoint, client_id, client_secret, children }) {
    const api = useApi(tokenEndpoint, client_id, client_secret);
    return React.createElement(AuthContext.Provider, { value: api }, children);
}
export function Authorized({ children }) {
    const [_, isLoggedIn] = useAuth();
    return isLoggedIn ? React.createElement(Routes, null,
        React.createElement(Route, { path: "/logout", element: React.createElement(Logout, null) }),
        React.createElement(Route, { path: "*", element: children })) : null;
}
export function Logout() {
    const [api] = useAuth();
    useEffect(function () {
        api.logout();
    }, [api]);
    return null;
}
export function NotAuthorized({ children }) {
    const [_, isLoggedIn] = useAuth();
    if (isLoggedIn)
        return null;
    var a = React.Children.toArray(children);
    var login = a.find(a => a.type === LoginRoute);
    var reset = a.find(a => a.type === ForgotPasswordRoute);
    var registerRoute = a.find(a => a.type === RegisterRoute);
    return React.createElement(LoginContext.Provider, { value: {
            login: login && '/login',
            reset: reset && '/reset',
            register: registerRoute && '/register'
        } },
        React.createElement(Routes, null,
            a.filter(a => a !== login && a !== reset && a !== registerRoute),
            login && React.createElement(Route, { path: "/login", element: login.props.children }),
            reset && React.createElement(Route, { path: "/reset", element: reset.props.children }),
            registerRoute && React.createElement(Route, { path: "/register", element: registerRoute.props.children }),
            React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: "/login" }) })));
}
export function LoginRoute(props) {
    return null;
}
export function ForgotPasswordRoute(props) {
    return null;
}
export function RegisterRoute(props) {
    return null;
}
